import React from 'react';

import Router from 'next/router';

import CustomError from '../components/Template/CustomError/CustomError';

import { Button } from '@lifepal/lifepal-design-system';

const Custom404 = () => {
  return (
    <CustomError>
      <p className="heading-xl-b title">Yah, Halaman Tidak Ditemukan.</p>
      <p className="body">Mungkin Anda salah memasukan Alamat, atau halaman sudah tidak ada.</p>
      <Button variant="primary" size="lg" isBlock onClick={() => Router.back()} className="mt-3">
        Kembali Ke Halaman Sebelumnya
      </Button>
    </CustomError>
  );
};

export default Custom404;
